import { createFileRoute } from '@tanstack/react-router';

import { InsightsFlow } from '../../features/onboarding/components/InsightsFlow';

export interface OnboardingSearch {
  preview?: 'cold-start';
}

export const Route = createFileRoute('/_onboarding/onboarding')({
  component: Onboarding,
  validateSearch: (search: Record<string, unknown>): OnboardingSearch => ({
    preview: search.preview === 'cold-start' ? 'cold-start' : undefined,
  }),
});

function Onboarding() {
  return <InsightsFlow />;
}
